var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5319_462)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15635 0.161955C5.92378 0.428298 4.15978 1.27627 2.6687 2.79987C1.32176 4.17617 0.549059 5.71815 0.222599 7.68117C0.130806 8.23313 0.130489 9.76246 0.222036 10.3179C0.480575 11.8864 1.06431 13.2442 1.99792 14.4488C2.31478 14.8576 3.005 15.5591 3.41809 15.8923C4.66364 16.8968 6.0456 17.5079 7.68174 17.7776C8.23492 17.8688 9.76527 17.8688 10.3185 17.7776C12.323 17.4472 13.9509 16.6099 15.3315 15.1992C16.6694 13.8321 17.4584 12.258 17.7782 10.3179C17.8693 9.76471 17.8693 8.23436 17.7782 7.68117C17.5147 6.08276 16.9209 4.71634 15.9597 3.49635C15.6491 3.10207 14.9857 2.43333 14.5809 2.10624C13.3509 1.11254 12.0206 0.51524 10.4259 0.240634C10.093 0.18333 9.81727 0.16547 9.14072 0.15749C8.66699 0.151865 8.22402 0.153869 8.15635 0.161955ZM8.3497 1.93706C5.90163 2.16611 3.71193 3.68001 2.63477 5.88821C1.67033 7.86532 1.67033 10.1337 2.63477 12.1109C3.59528 14.0799 5.42235 15.4955 7.58115 15.9432C10.7297 16.5961 13.954 15.0075 15.3675 12.107C16.183 10.4335 16.3105 8.55762 15.7292 6.78469C14.704 3.65821 11.6184 1.63124 8.3497 1.93706ZM13.2188 5.33256C12.9244 5.3816 12.9301 5.37633 10.1954 8.10562L7.50595 10.7897L6.15346 9.44974C5.15579 8.46133 4.76039 8.09187 4.64631 8.04139C4.46012 7.95901 4.14463 7.95131 3.96867 8.02483C3.79525 8.09728 3.5957 8.28119 3.50591 8.45127C3.39981 8.65226 3.3996 9.03103 3.50549 9.22805C3.61644 9.43456 6.97865 12.7789 7.14448 12.8477C7.32602 12.923 7.68258 12.9164 7.85752 12.8345C7.9543 12.7892 8.95274 11.8112 11.0599 9.6976C14.372 6.37547 14.2055 6.56169 14.2017 6.18296C14.1984 5.85625 14.0195 5.57025 13.7339 5.43515C13.5416 5.3442 13.3628 5.30858 13.2188 5.33256Z",
    fill: "#105B3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5319_462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTik);
export default __webpack_public_path__ + "static/media/right-tik.a1263f6d0e8d3148d827c64f1c4a3a8d.svg";
export { ForwardRef as ReactComponent };